import http from "../http-common-2";

class InstantBookingDataService {
  getBookings() {
    return http.get(`/instantsupport`);
  }

  getSingleBooking(id: any) {
    return http.get(`/instantsupport/${id}`);
  }

  deleteBooking(id: any) {
    return http.delete(`/instantsupport/${id}`);
  }
}
export default new InstantBookingDataService();
